"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageTranslationsProvider = void 0;
var _i18n = require("@ori/i18n");
var _react = _interopRequireDefault(require("react"));
var _logger = require("../../logger");
var _translations = require("../default/translations");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('ErrorPageTranslationsProvider');

/**
 * Provides translations for the error page layout.
 * Since Error page needs to refetch translations on client, we need to add this possibility
 *
 * @component
 * @param {boolean} shouldRefetchtranslations Indicates whether translations should be refetched.
 * @param {React.ReactNode} children The child components.
 * @param {TranslationsWithNamespaces} translations The translations for the error page.
 * @param {string} language The language for the translations.
 * @param {string} tenant The tenant for the translations.
 * @param {string} staticApiUrl The static API URL for fetching translations.
 * @returns {React.ReactNode} The rendered component.
 */
const ErrorPageTranslationsProvider = ({
  shouldRefetchtranslations,
  children,
  translations,
  language,
  tenant,
  staticApiUrl
}) => {
  if (shouldRefetchtranslations) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
      language: language,
      defaultTranslationsWithNamespaces: translations,
      clientFetchConfiguration: {
        baseUrl: staticApiUrl ?? '',
        tenant,
        onError: error => logger.error(new Error('Failed to fetch translations', {
          cause: error
        }))
      },
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    language: language,
    defaultTranslationsWithNamespaces: _translations.defaultLayoutTranslationKeysWithNamespaces,
    translationsWithNamespaces: translations,
    children: children
  });
};
exports.ErrorPageTranslationsProvider = ErrorPageTranslationsProvider;
